import { getToken } from '../utils/getToken'

import { wrapFetch } from './FetchHelper'

export const UserProfileService = {
  getProfile: () => {
    return wrapFetch(
      fetch('/api/userprofile', {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }),
    ).onSuccess(json => json)
  },

  updateProfile: profile => {
    return wrapFetch(
      fetch('/api/userprofile', {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${getToken()}`,
        },
        body: JSON.stringify(profile),
      }),
    ).onSuccess(json => json)
  },
}
